import { useTranslation } from 'react-i18next';

export default function AudienceSplit() {
  const { t } = useTranslation();

  const handleCompanyClick = () => {
    window.REACT_APP_NAVIGATE('/empresa');
  };

  const handleProfessionalClick = () => {
    window.REACT_APP_NAVIGATE('/perfil');
  };

  return null;
}